import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useDispatch } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';
import { APPLICATION_FOUND_URL, CREDIT_PORTAL_URL, H1, NO_APPLICATIONS_URL, P, } from 'shared';
import { useLazyGetConsumerApplicationsV1CreditApplicationsStatusStatusQuery, } from 'consumer-applications-v1-api';
import LoginImage from 'images/PMP_Login_Image.png';
import { ApplicationFinderForm } from '../../forms';
import { setPersonalInfo, setPrequalifications } from '../actions';
import { getContinuablePrequalifications } from '../utils';
const logo = '/Alphaeon_Patient_Financing_Logo_SVG.svg';
function ApplicationFinder() {
    const history = useHistory();
    const dispatch = useDispatch();
    const [getCreditApplicationsByStatus, { isFetching }] = useLazyGetConsumerApplicationsV1CreditApplicationsStatusStatusQuery();
    const handleFound = (prequalifications, applicant) => {
        dispatch(setPrequalifications(prequalifications));
        if (applicant) {
            dispatch(setPersonalInfo(applicant));
        }
        history.push(APPLICATION_FOUND_URL);
    };
    // The API returns a 422 when no application with this status exists — the
    // expected "no match" we probe for. Any other error is an unexpected failure,
    // so we bail instead of falsely routing the user to the no-applications page.
    const isExpectedMiss = (result) => result.error != null &&
        typeof result.error === 'object' &&
        'status' in result.error &&
        result.error.status === 422;
    const handleSubmit = async (formValues) => {
        const { ssnLastFour, dateOfBirth, zip } = formValues;
        const searchArgs = { ssnLastFour, dateOfBirth, zip };
        const prequalified = await getCreditApplicationsByStatus({
            ...searchArgs,
            status: 'prequalified',
        });
        const prequalifiedMatches = getContinuablePrequalifications(prequalified.data?.prequalifications);
        if (prequalifiedMatches.length > 0) {
            return handleFound(prequalifiedMatches, prequalified.data?.applicant);
        }
        // A 200 with nothing continuable is treated like the expected 422 miss;
        // any other error bails so the user isn't wrongly routed to NO_APPLICATIONS_URL.
        if (!prequalified.data && !isExpectedMiss(prequalified)) {
            return;
        }
        const pending = await getCreditApplicationsByStatus({
            ...searchArgs,
            status: 'pending',
        });
        const pendingMatches = getContinuablePrequalifications(pending.data?.prequalifications);
        if (pendingMatches.length > 0) {
            return handleFound(pendingMatches, pending.data?.applicant);
        }
        if (!pending.data && !isExpectedMiss(pending)) {
            return;
        }
        history.push(NO_APPLICATIONS_URL);
    };
    return (_jsxs("div", { className: "application-finder-container min-height-600", children: [_jsx("div", { className: "left-content-container", children: _jsx("img", { src: LoginImage, alt: "Person holding an Alphaeon credit card" }) }), _jsxs("div", { className: "right-content-container", children: [_jsxs("header", { children: [_jsx("img", { className: "logo", src: logo, alt: "Alphaeon logo", width: 224, height: 59 }), _jsx(H1, { variant: "headline-medium", children: "Let's Find Your Application" })] }), _jsx(ApplicationFinderForm, { handleSubmit: handleSubmit, submitting: isFetching }), _jsxs(P, { children: ["Haven't applied yet? ", _jsx(Link, { to: CREDIT_PORTAL_URL, children: "Apply" })] })] })] }));
}
export default ApplicationFinder;
